import { find, map } from "lodash"
// Création d'une liste d'option pour un select avec value _id.$oid
export const transformDataInSelectPerOid = (data, keyName1, keyName2, separator) => {
  const dataSelect = map(data, item => {
    const labelName = keyName2 ? `${item[keyName1]} ${separator} ${item[keyName2]}` : item[keyName1]
    return {
      label: labelName,
      value: item?._id?.$oid,
    }
  })

  return dataSelect
}
// Création d'une liste d'option pour un select
export const transformDataInSelect = (data, keyName, keyValue) => {
  const dataSelect = map(data, item => {
    return {
      label: item[keyName],
      value: item[keyValue],
    }
  })

  return dataSelect
}
// Création d'une liste d'option pour un select avec 2 keyName
export const transformDataInSelectMultiKeyName = (
  data,
  keyValue,
  separator,
  keyName1,
  keyName2
) => {
  const dataSelect = map(data, item => {
    const labelName = keyName2 ? `${item[keyName1]} ${separator} ${item[keyName2]}` : item[keyName1]
    return {
      label: labelName,
      value: item[keyValue],
    }
  })

  return dataSelect
}
// Récupération de l'object selectionné dans un select
export const getObjectValueSelect = (list, value) => {
  const objetSelected = find(list, { value: value })
  return objetSelected
}
// Création d'une liste d'option pour un select
export const transformArrayInSelect = data => {
  const dataSelect = map(data, item => {
    return {
      label: item,
      value: item,
    }
  })

  return dataSelect
}
